module.exports = __webpack_public_path__ + "media/images/countryrect/ws-f8c55fed85be89fc76317fce3010bc32.svg";